module.exports = __webpack_public_path__ + "static/media/bd3419ba-d795-426f-ae33-3443113adc63.464af535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/bd3419ba-d795-426f-ae33-3443113adc63.png
// module id = 1493
// module chunks = 0